import { render, staticRenderFns } from "./Prosper.vue?vue&type=template&id=35198aaf&lang=pug&"
import script from "./Prosper.vue?vue&type=script&lang=ts&"
export * from "./Prosper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports